import type { ReactNode } from 'react';

export const symbol_vignette_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M650-310q70-70 70-170t-70-170q-70-70-170-70t-170 70q-70 70-70 170t70 170q70 70 170 70t170-70ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Zm172 427.5Q300-405 300-480t52-127.5Q404-660 479-660t127.5 52.5Q659-555 659-480t-52.5 127.5Q554-300 479-300t-127-52.5Z"
		/>
	</svg>
);
